// extracted by mini-css-extract-plugin
export default {"googlePlay":"GooglePlay_googlePlay__dE4px"};